import { PERMISSIONS } from '@moleculeone/auth';
import { useSelector } from 'react-redux';

import { hasAnyPermission } from '@f/services/authentication/authentication.selectors';

export function useIsDebugModeOn() {
  const isDebugModeOn = useSelector((state: any) => {
    return state.administration.debug.isDebugModeEnabled;
  });

  const hasDebugRole = useSelector(state => {
    return hasAnyPermission(state, [PERMISSIONS.RETRO.DEBUG]);
  });

  return isDebugModeOn && hasDebugRole;
}
